import $ from "jquery";
import "jquery-match-height";
import "jquery-mousewheel";

import {
    addToCompare,
    removeElemCompare,
    removeAllCompare,
    loadCompare,
    showCompare,
} from "./utils";

const compare = () => {
    //добавление в сравнение при клике на кнопку
    $(document).on("click", ".js-compare", function (e) {
        const target = e.currentTarget;

        addToCompare(target);
    });

    if ($(".compare:not(.icons__item)").length) {
        loadCompare();

        //==================одинаковая высота характеристик
        let charNames = [];

        //подставляем какие-нибудь рандомные атрибуты к характеристикам
        $(".compare__content .item").each(function () {
            $(this)
                .find("> div")
                .each(function (i) {
                    $(this).attr("data-char", i);
                });
        });

        //перебираем характеристики в дефолтном элементе
        $(".compare__content .item.item_default div[data-char]").each(
            function () {
                let char = $(this).attr("data-char");

                charNames.push(char);
            }
        );

        //Перебираем характеристики и подставляем высоты
        charNames.forEach((item) => {
            $(`.compare__content .item div[data-char="${item}"]`).matchHeight();
        });
        // ===============================

        //Смена отображения при скролле
        $(window).on("scroll", function () {
            if ($(".compare__head").length) {
                let headOffsetTop =
                    $(".compare__head").offset().top +
                    $(".compare__head").height() -
                    $(document).scrollTop();
                let contentOffsetTop =
                    $(".compare__content").offset().top +
                    $(".compare__content").height() -
                    140 -
                    $(document).scrollTop();

                if (headOffsetTop < 0) {
                    $(".compare__head").addClass("fixed");

                    if (contentOffsetTop < 0) {
                        $(".compare__head").removeClass("fixed");
                    } else {
                        $(".compare__head").addClass("fixed");
                    }
                } else {
                    $(".compare__head").removeClass("fixed");

                    $(".compare__head-wrap").css({
                        "-webkit-transform": `translateX(0px)`,
                        "-ms-transform": `translateX(0px)`,
                        transform: `translateX(0px)`,
                    });
                }
            }
        });

        //горизонтальный скролл

        //по колесику мыши
        if ($(window).width() > 992) {
            $(".scroll-table").mousewheel(function (event, delta) {
                console.log(1);
                this.scrollLeft -= delta * 50;

                event.preventDefault();
            });
        }

        $(".scroll-table").on("scroll", function (e) {
            let horizontal = e.currentTarget.scrollLeft;

            //перемещение подписей строк характеристик
            $(".compare__content .label").css({
                "-webkit-transform": `translateX(${horizontal}px)`,
                "-ms-transform": `translateX(${horizontal}px)`,
                transform: `translateX(${horizontal}px)`,
            });

            if ($(".compare__head").hasClass("fixed")) {
                $(".compare__head-wrap").css({
                    "-webkit-transform": `translateX(-${horizontal}px)`,
                    "-ms-transform": `translateX(-${horizontal}px)`,
                    transform: `translateX(-${horizontal}px)`,
                });
            }
        });

        //Удаление элементов
        function removeAll() {
            $(".compare .scroll-table").remove();
            $(".tags").remove();
            $(".compare__footer .price .result").text("В сравнении пусто");
        }

        function checkItems() {
            if (!$(".item:not(.item_default)").length) {
                removeAll();
            }
        }

        $(".btns__delete").on("click", function (e) {
            const target = e.currentTarget;
            const itemId = $(target).attr("data-id");

            // Запись в куки
            removeElemCompare(target);

            showCompare();

            $(`.item[data-id="${itemId}"]`).remove();

            checkItems();
        });

        //Удалить всё
        $(".compare__btns .delete").on("click", function () {
            // запись в куки
            removeAllCompare();
            showCompare();
            removeAll();
        });

        // Показать только различия
        $("[name=differences]").on("change", function () {
            if ($(this).is(":checked")) {
                charNames.forEach((item) => {
                    // new Set() хранит в себе только уникальные значения
                    let charSet = new Set();

                    $(
                        `.compare__content .item:not(.item_default) div[data-char="${item}"]`
                    ).each(function () {
                        charSet.add($(this).text().trim());
                    });

                    if (charSet.size == 1) {
                        $(
                            `.compare__content .item div[data-char="${item}"]`
                        ).hide();
                    }
                });
            } else {
                $(`.compare__content .item div[data-char]`).show();
            }
        });
    }
};

export default compare;
